import operatorsController from "../../api/controllers/operators"
import { AcceptInviteOperatorFunction } from "../../models/operator"

export const handleAcceptInviteOperator =
    (projectId?: string): AcceptInviteOperatorFunction =>
    (operatorId, dialogId, notificationId) =>
        projectId && operatorsController.connectOperator(projectId, operatorId, dialogId, notificationId)
